module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.lacres), function(lacre) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "max-width": "25%",
        "width": "25%"
      },
      attrs: {
        "scope": "row",
        "width": "25%"
      }
    }, [_vm._v(_vm._s(lacre.numero))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lacre.numero),
        expression: "lacre.numero"
      }],
      staticClass: "form-control",
      attrs: {
        "id": lacre.id,
        "type": "text"
      },
      domProps: {
        "value": (lacre.numero)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lacre, "numero", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lacre.violado),
        expression: "lacre.violado"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'violado-' + lacre.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(lacre.violado) ? _vm._i(lacre.violado, null) > -1 : (lacre.violado)
      },
      on: {
        "change": function($event) {
          var $$a = lacre.violado,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(lacre, "violado", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(lacre, "violado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(lacre, "violado", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "scope": "row"
      }
    }, [_c('label', {
      staticClass: "i-switch bg-danger m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lacre.apagar),
        expression: "lacre.apagar"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'del-' + lacre.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(lacre.apagar) ? _vm._i(lacre.apagar, null) > -1 : (lacre.apagar)
      },
      on: {
        "change": function($event) {
          var $$a = lacre.apagar,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(lacre, "apagar", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(lacre, "apagar", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(lacre, "apagar", $$c)
          }
        }
      }
    }), _c('i')])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [_c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarLacre
    }
  }, [_vm._v("\n      Adicionar outro lacre\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Violado")]), _vm._v(" "), _c('th', [_vm._v("Apagar?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-769b5b32","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv/LacresGrv.vue
// module id = 1762
// module chunks = 17